import { render } from "./ModelComponent.vue?vue&type=template&id=0ab5b58f"
import script from "./ModelComponent.vue?vue&type=script&lang=js"
export * from "./ModelComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__